import * as actionTypes from "../actionTypes";

export const getSubCategory = payload => ({
    type: actionTypes.GET_SUB_CATEGORY,
    payload
})

export const setSubCategory = payload => ({
    type: actionTypes.SET_SUB_CATEGORY,
    payload
})

export const createSubCategory = payload => ({
    type: actionTypes.CREATE_SUB_CATEGORY,
    payload
})

export const updateSubCategory = payload => ({
    type: actionTypes.UPDATE_SUB_CATEGORY,
    payload
})

export const deleteSubCategory = payload => ({
    type: actionTypes.DELETE_SUB_CATEGORY,
    payload
})

export const changeSubCategoryStatus = payload => ({
    type: actionTypes.CHANGE_SUB_CATEGORY_STATUS,
    payload
})

export const getSubCategoryByCategoryId = payload => ({
    type: actionTypes.GET_SUB_CATEGORY_BY_CATEGORY_ID,
    payload
})

export const setSubCategoryByCategoryId = payload => ({
    type: actionTypes.SET_SUB_CATEGORY_BY_CATEGORY_ID,
    payload
})
